module.exports = __webpack_public_path__ + "img/loading.377c8c4d.gif";